import React, { useEffect, useCallback } from 'react';
import { TechnologyDropdown } from 'domain/shared/career';
import { useInputHelper } from 'framework/form';
import { ADDITIONAL_POSITIONS } from '../../../constants';
import { InputComponentProps } from './types';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';

const AVAILABLE_POSITIONS_FOR_TECH = ['Software Engineer', 'Education Specialist'];

const TechnologyTemplateField = ({ source, propertyDetails, renderNestedProperties }: InputComponentProps) => {
  const fieldSource = `${source}.${propertyDetails.propertyName}`;
  const parentSource = source.replace(/\.properties$/, 'value');

  const { getRawOnChangeCallback, initializeValue, getValue: getFieldValue } = useInputHelper({ source: fieldSource });

  const { getValue: getParentValue } = useInputHelper({ source: parentSource });

  const currentValue = getFieldValue();
  const parentValue = getParentValue() as keyof typeof ADDITIONAL_POSITIONS;

  const shouldRenderTechnology = AVAILABLE_POSITIONS_FOR_TECH.includes(parentValue);

  const rawOnChange = getRawOnChangeCallback();

  const onChangeCallback = useCallback(
    (data: FormFieldsData) => {
      if (rawOnChange) {
        rawOnChange({
          [fieldSource]: [{ value: Object.values(data)[0] }],
        });
      }
    },
    [rawOnChange, fieldSource],
  );

  useEffect(() => {
    if (!currentValue || !currentValue.length || !shouldRenderTechnology) {
      initializeValue(shouldRenderTechnology ? [{ value: '' }] : []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRenderTechnology]);

  if (!shouldRenderTechnology) return null;

  return (
    <>
      <TechnologyDropdown
        label=""
        idSource="name"
        placeholder="Technology"
        onChangeCallback={onChangeCallback}
        source={`${fieldSource}.0.value`}
      />
      {renderNestedProperties?.({
        propertiesSource: `${fieldSource}.0.properties`,
        propertiesShema: propertyDetails.properties,
      })}
    </>
  );
};

export default TechnologyTemplateField;
